__turbopack_context__.v({
  "btn": "forgot-password-module-scss-module__dLflhW__btn",
  "card": "forgot-password-module-scss-module__dLflhW__card",
  "container": "forgot-password-module-scss-module__dLflhW__container",
  "error": "forgot-password-module-scss-module__dLflhW__error",
  "field": "forgot-password-module-scss-module__dLflhW__field",
  "footer": "forgot-password-module-scss-module__dLflhW__footer",
  "footerLink": "forgot-password-module-scss-module__dLflhW__footerLink",
  "form": "forgot-password-module-scss-module__dLflhW__form",
  "input": "forgot-password-module-scss-module__dLflhW__input",
  "label": "forgot-password-module-scss-module__dLflhW__label",
  "link": "forgot-password-module-scss-module__dLflhW__link",
  "logo": "forgot-password-module-scss-module__dLflhW__logo",
  "logoIcon": "forgot-password-module-scss-module__dLflhW__logoIcon",
  "logoLink": "forgot-password-module-scss-module__dLflhW__logoLink",
  "logoText": "forgot-password-module-scss-module__dLflhW__logoText",
  "shimmer": "forgot-password-module-scss-module__dLflhW__shimmer",
  "spin": "forgot-password-module-scss-module__dLflhW__spin",
  "spinner": "forgot-password-module-scss-module__dLflhW__spinner",
  "stepActive": "forgot-password-module-scss-module__dLflhW__stepActive",
  "stepDone": "forgot-password-module-scss-module__dLflhW__stepDone",
  "stepDot": "forgot-password-module-scss-module__dLflhW__stepDot",
  "steps": "forgot-password-module-scss-module__dLflhW__steps",
  "subtitle": "forgot-password-module-scss-module__dLflhW__subtitle",
  "success": "forgot-password-module-scss-module__dLflhW__success",
  "successIcon": "forgot-password-module-scss-module__dLflhW__successIcon",
  "title": "forgot-password-module-scss-module__dLflhW__title",
});
